import Router from "@/src/components/router";

export default function Index() {
  return (
    <Router
      routes={[
        { text: "Product Form", componentUrl: "/(auth)/merchant/product-form" },
      ]}
    />
  );
}
